var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-text',{staticClass:"app-link",class:( _obj = {}, _obj['underline-' + _vm.underline] = _vm.underline, _obj ),attrs:{"size":_vm.size,"weight":_vm.weight,"color":_vm.color,"type":"a","href":_vm.href,"target":_vm.targetComputed},on:{"click":_vm.click}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }